import { render, staticRenderFns } from "./PayableWriteoff.vue?vue&type=template&id=44bb97bc&scoped=true&"
import script from "./PayableWriteoff.vue?vue&type=script&lang=js&"
export * from "./PayableWriteoff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bb97bc",
  null
  
)

export default component.exports